module.exports = __webpack_public_path__ + "img/angle-down-td.c5a38b51.svg";